export default "__VITE_ASSET__iOBwzka0__"